<template>
  <b-container fluid>
    <backlink />
    <h1>Demandes de transfert</h1>

    <AdminTable :config="config" :options="options" :items_provider="itemsProvider">
      <template slot="group_slugs" slot-scope="{ data }">
        <div style="width: 75px">
          <b-badge v-if="data.value.includes('outillage')" variant="outillage" class="circle float-left" v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('outillage').text">
            <i class="fa fa-check"></i>
          </b-badge>
          <b-badge v-else variant="transparent" class="circle float-left" v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('outillage').text">
            &nbsp;
          </b-badge>
          <b-badge v-if="data.value.includes('instruments')" variant="instruments" class="circle float-left"
            v-b-tooltip.hover :title="$store.getters['renting_preparation/getGroup']('instruments').text">
            <i class="fa fa-check"></i>
          </b-badge>
          <b-badge v-else variant="transparent" class="circle float-left" v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('outillage').text">
            &nbsp;
          </b-badge>
          <b-badge v-if="data.value.includes('service_et_logistique')" variant="service_et_logistique"
            class="circle float-left" v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('service_et_logistique').text">
            <i class="fa fa-check"></i>
          </b-badge>
        </div>
      </template>
    </AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTableSync";
import config from "./config";

export default {
  name: "TransferList",
  components: {
    AdminTable,
  },
  data() {
    return {
      config: config,
    };
  },
  computed: {
    options: function () {
      return {
        group_slugs_options: this.$store.getters["renting_preparation/getGroups"],
      };
    },
  },
  methods: {
    /**
     * Fourni les données à AdminTableSync. Cette méthode est appelée à chaque 
     * rafraichissement de la liste
     * @param   {object}  ctx   Objet context envoyé par b-table
     * @returns {object}        {
                                  total: Nombre total de résultats,
                                  items: Items à afficher
                                }
     */
    itemsProvider(ctx) {
      var self = this;
      return new Promise(function (resolve, reject) {
        self.$http
          .get(process.env.BACK_API_URL + "transfer", {
            params: {
              page: ctx.currentPage,
              limit: ctx.perPage,
              sortBy: ctx.sortBy,
              sortDesc: ctx.sortDesc ? "DESC" : "ASC",
              search: ctx.filter,
              group_slug: ctx.extended_filters_model.group_slugs,
            },
          })
          .then((response) => {
            resolve({
              total: response.data.total,
              page: parseInt(response.data.page),
              items: response.data.transfers || [],
            });
          })
          .catch((error) => {
            self.$toastr.error("Le chargement de la liste a échoué");
            self.inGenerating = false;
          });
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Transfer/TransferList.vue